import { render, staticRenderFns } from "./contentlist.vue?vue&type=template&id=5ccb2a70&scoped=true"
import script from "./contentlist.vue?vue&type=script&lang=js"
export * from "./contentlist.vue?vue&type=script&lang=js"
import style0 from "./contentlist.vue?vue&type=style&index=0&id=5ccb2a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccb2a70",
  null
  
)

export default component.exports